import TemplatesServices from '@/services/TemplatesService.js';
import { encryptStorage } from '@/utils/storage.js';

const template = {
  namespaced: true,
  state: {
    templates: [],
    templatesFiltered: [],
    templatesPbx: [],
    templatesFilteredPbx: [],
    templatesPbxVideos: [],
    templatesFilteredPbxVideos: [],
    defaultMessages: [],
    defaultMessagesFiltered: [],
    showTemplates: false,
    toggleTemplatesMessages: false,
    template: '',
    selectedTemplate: '',
    titleTemplateSelect: '',
  },
  mutations: {
    SET_IS_LOADING_TEMPLATE(state, value) {
      state.isLoadingTemplate = value;
    },
    LOAD_TEMPLATE(state, template) {
      state.template = template;
    },
    LOAD_TEMPLATES(state, templates) {
      state.templates = templates;
      state.templatesFiltered = templates;
    },
    LOAD_TEMPLATES_PBX(state, templates) {
      state.templatesPbx = templates;
      state.templatesFilteredPbx = templates;
    },
    LOAD_TEMPLATES_PBX_VIDEOS(state, templates) {
      state.templatesPbxVideos = templates;
      state.templatesFilteredPbxVideos = templates;
    },
    LOAD_FILTERED_TEMPLATES(state, messages) {
      state.templatesFiltered = messages;
    },
    LOAD_MESSAGES(state, messages) {
      state.defaultMessages = messages;
      state.defaultMessagesFiltered = messages;
    },
    LOAD_FILTERED_MESSAGES(state, messages) {
      state.defaultMessagesFiltered = messages;
    },
    TOGGLE_TEMPLATES(state, value) {
      state.showTemplates = value;
      if (value) {
        state.toggleTemplatesMessages = false;
      }
    },
    TOGGLE_TEMPLATES_MESSAGES(state, value) {
      state.toggleTemplatesMessages = value;
      if (value) {
        state.showTemplates = false;
      }
    },
    LOAD_VARIABLES_TEMPLATES(state, variables) {
      state.variablesTemplates = variables;
    },
    SET_IS_LOADING_DEFAULT_MESSAGES(state, value) {
      state.isLoadingDefaultMessages = value;
    },
    SELECT_TEMPLATE(state, template) {
      state.selectedTemplate = template;
    },
    SET_TITLE(state, title) {
      state.titleTemplateSelect = title;
    },
  },
  actions: {
    async fetchTemplates({ commit }) {
      const join = encryptStorage.getItem('user').join
      const token = join.tokenJoin;
      return TemplatesServices.getTemplates(token)
        .then((response) => {
          console.log('retriving templates', response);
          commit('LOAD_TEMPLATES', response.data);
          return 'Success';
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async fetchTemplatesPbxImages({ commit }) {
      const join = encryptStorage.getItem('user').join
      const token = join.tokenJoin;
      return TemplatesServices.getTemplatesPbxImages(token)
        .then((response) => {
          const formatData = response.data.results.map((template) => {
            if (template.type_display === 'image'&& template.status.toLowerCase()==="success" && template.gupshup_id !== null) {
              return {
                id: template.gupshup_id,
                title: template.name,
                message: template.gupshup_format,
                type_message: template.type_display,
                type_template: 'pbx_template',
                file_template: template.file
              }
            } 
            return null
          }).filter(item => item !== null);
          commit('LOAD_TEMPLATES_PBX', formatData)
          return 'Success';
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async fetchTemplatesPbxVideos({ commit }) {
      const join = encryptStorage.getItem('user').join
      const token = join.tokenJoin;
      return TemplatesServices.getTemplatesPbxVideos(token)
        .then((response) => {
          const formatData = response.data.results.map((template) => {
            if (template.type_display === 'video' && template.status.toLowerCase()==="success" && template.gupshup_id !== null) {
              return {
                id: template.gupshup_id,
                title: template.name,
                message: template.gupshup_format,
                type_message: template.type_display,
                type_template: 'pbx_template',
                file_template: template.file
              }
            } 
            return null
          }).filter(item => item !== null);
          commit('LOAD_TEMPLATES_PBX_VIDEOS', formatData)
          return 'Success';
        })
        .catch((error) => {
          console.log(error);
        });
    },
    

    async fetchDefaultMessages({ commit }) {
      const join = encryptStorage.getItem('user').join
      const token = encryptStorage.getItem('token');
      let isAdmin = true;
      let admin = encryptStorage.getItem('user').Username;
      if (join.isAdmin !== true) {
        isAdmin = false;
        admin = join.adminUser;
      } else if (join.isSupervisor === true) {
        admin = join.adminUser;
        isAdmin = false;
      }
      return TemplatesServices.getDefaultMessages(token, admin, isAdmin)
        .then((response) => {
          commit('LOAD_MESSAGES', response.data.data);
          return 'Success';
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};

export default template;
